// src/components/FooterSimple.jsx

import React from 'react';
import { Container, Group, ActionIcon, Text, Box } from '@mantine/core';
import {
  IconBrandTwitter,
  IconBrandYoutube,
  IconBrandInstagram,
} from '@tabler/icons-react';
import classes from './FooterSimple.module.css';

export function FooterSimple() {
  return (
    // Kita gunakan <Box> sebagai wrapper,
    // karena <AppShell.Footer> akan menjadi wrapper utamanya
    <Box className={classes.footer}>
      <Container fluid className={classes.inner}>
        
        {/* Teks Copyright (kiri) */}
        <Text c="dimmed" size="sm">
          © {new Date().getFullYear()} GiziMon. All rights reserved.
        </Text>
        
        {/* Ikon Sosial (kanan) */}
        <Group gap="sm" className={classes.links} justify="flex-end">
          <ActionIcon size="lg" color="gray" variant="subtle">
            <IconBrandTwitter size={18} stroke={1.5} />
          </ActionIcon>
          <ActionIcon size="lg" color="gray" variant="subtle">
            <IconBrandYoutube size={18} stroke={1.5} />
          </ActionIcon>
          <ActionIcon size="lg" color="gray" variant="subtle">
            <IconBrandInstagram size={18} stroke={1.5} />
          </ActionIcon>
        </Group>

      </Container>
    </Box>
  );
}